import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { CopyAuthSecretButton } from '@modules/workspaceSettings/components/SSOSettings/CopyAuthSecretButton';
import { RemoveSSOModalContent } from '@modules/workspaceSettings/components/SSOSettings/RemoveSSOModalContent';
import { useFetchTenantSSOSettings } from '@modules/workspaceSettings/hooks';
import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';
import { ConfigureSSOModalContent } from './ConfigureSSOModalContent';

export const ConfigureSSOActions = () => {
  const { ssoSettings, isLoading } = useFetchTenantSSOSettings();
  const isSSOEnabled = ssoSettings?.isEnabled;

  const { openModal } = useMuiModalContext();

  const openRemoveSSOModal = () => {
    openModal({
      contentComponent: () => <RemoveSSOModalContent />,
      modalProps: {
        fullWidth: true,
        maxWidth: 'xs',
        PaperProps: {
          elevation: 3,
        },
      },
    });
  };

  const openConfigureSSOModal = () => {
    openModal({
      contentComponent: () => <ConfigureSSOModalContent />,
      modalProps: {
        shouldDisableBackdropClick: true,
        fullWidth: true,
        maxWidth: 'xs',
        PaperProps: {
          elevation: 3,
        },
      },
    });
  };

  if (!isSSOEnabled) {
    return (
      <LoadingButton
        loading={isLoading}
        variant="contained"
        onClick={openConfigureSSOModal}
      >
        Configure
      </LoadingButton>
    );
  }

  return (
    <Stack direction="row" spacing={2}>
      <CopyAuthSecretButton />
      <Button variant="outlined" color="error" onClick={openRemoveSSOModal}>
        Remove SSO
      </Button>
      <Button variant="outlined" onClick={openConfigureSSOModal}>
        Modify
      </Button>
    </Stack>
  );
};
